// Configuration des URLs API
export const API_BASE_URL = 'https://oosmosegroupe.lv2304.cloud/api';

export const API_ENDPOINTS = {
  USERS: `${API_BASE_URL}/users`,
  USERS_INFORMATIONS: `${API_BASE_URL}/users_informations`,
};
